import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "../components/form/Dropdown";
import LogoutModal from "../components/LogoutModal/LogoutModal";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { resetStep, setIsComingFromNonUserRoute } from "../redux/slice/stepSlice";
import { setCoverImages, setImages } from "../redux/slice/sketchSlice";
import { saveStep } from "../services/stepService";
import Button from "../components/form/Button";
// import { markStepAsVisited } from "../services/commonService";
import { markStepAsVisited } from "../redux/slice/profileSlice";
import { frontRoutes } from "../config/RoutesConfig";

const UserDropdown = ({ user }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { session } = useSelector((state) => state.authProvider);
  const { myBooks } = useSelector((state) => state.profile);
  const { activeBookId } = useSelector((state) => state.stepFlow);
  const [isLogoutModelOpen, setIsLogOutModelOpen] = useState(false);

  const orderedBooks = myBooks.filter((book) => !!book.isOrderPlaces);

  const onColoringBookNavigate = () => {
    if (!!activeBookId && !!orderedBooks.length) {
      dispatch(resetStep());
      dispatch(setCoverImages([]));
      dispatch(setImages([]));

      if (location.pathname === "/") dispatch(setIsComingFromNonUserRoute(true));
    } else if (!!activeBookId && myBooks.length === 1) {
      saveStep({
        userId: session?.user?._id,
        bookId: activeBookId,
        isCompleted: 'yes',
        stepCode: "Upload_Your_Cover_Photo",
      });
      dispatch(markStepAsVisited({ id: activeBookId, currentStepCode: 'Upload_Your_Cover_Photo' }));
    } else if (!activeBookId && location.pathname.includes("create-book") && myBooks.length <= 1) {
      return;
    }

    navigate("/dashboard");
  };

  const dropdownData = [
    /* ...(
      !!orderedBooks.length && !!activeBookId ? [{
        name: "Switch Book",
        icon: "fa-regular fa-box text-lg",
        standout: false,
        click: () => {
          dispatch(resetStep())
          dispatch(setCoverImages([]))
          dispatch(setImages([]))
          if (location.pathname === '/') dispatch(setIsComingFromNonUserRoute(true))
          navigate("/dashboard")
        },
      }] : []
    ), */
    ...[
      /* {
        name: "Coloring Books",
        icon: "fa-regular fa-box text-lg",
        standout: false,
        click: onColoringBookNavigate,
      }, */
      {
        name: "Logout",
        icon: "fa-regular fa-arrow-right-from-bracket text-lg",
        standout: true,
        click: () => {
          setIsLogOutModelOpen(true);
        },
      },
    ],
  ];

  return (
    <>
      {(location.pathname === "/dashboard" && !activeBookId) ? (
        <>
          <Dropdown
            data={dropdownData}
            buttonClasses={"flex items-center justify-center !space-x-0 !gap-2 aspect-square sm:aspect-[unset] !h-12 sm:!h-10 !px-0 sm:!px-4 !py-2 !rounded-full bg-md-pink-light-2 hover:bg-md-pink-light-1 border border-md-pink-light-1 !text-md-dark text-sm font-medium transition-all duration-200"}
            buttonIcon={"fa-regular fa-user text-xl sm:text-base"}
            buttonIconPosition={"left"}
            buttonLabel={"Account"}
            // showTransition={location.pathname === '/dashboard' && !activeBookId}
            xPlacement="bottomRight"
            buttonArrowIcon={""}
            buttonLabelClasses={"hidden sm:block"}
          />
        </>
      ) : (
        (!!activeBookId && !orderedBooks.length && !frontRoutes().map(item => item.path).includes(location.pathname)) ? (
          <Button
            buttonClasses={"flex items-center justify-center w-10 aspect-square !h-10 !px-0 !rounded-full bg-slate-700 text-white"}
            buttonIcon={"fa-regular fa-right-from-bracket"}
            buttonIconPosition={"left"}
            buttonFunction={() => setIsLogOutModelOpen(true)}
          />
        ) : (
          <Button
            buttonClasses={"flex items-center justify-center w-10 aspect-square !h-10 !px-0 !rounded-full bg-slate-700"}
            buttonLabel="A"
            buttonLabelClasses={"text-white"}
            buttonFunction={onColoringBookNavigate}
          />
        )
      )}

      <LogoutModal 
        setIsOpen={(val) => setIsLogOutModelOpen(val)} 
        isOpen={isLogoutModelOpen} 
      />
    </>
  );
};

export default UserDropdown;
